const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Common domain typos → correction */
const DOMAIN_TYPOS = {
	'gmial.com': 'gmail.com',
	'gmal.com': 'gmail.com',
	'gmail.co': 'gmail.com',
	'gmail.con': 'gmail.com',
	'gnail.com': 'gmail.com',
	'gamil.com': 'gmail.com',
	'hotmial.com': 'hotmail.com',
	'hotmal.com': 'hotmail.com',
	'hotmail.co': 'hotmail.com',
	'yahooo.com': 'yahoo.com',
	'yaho.com': 'yahoo.com',
	'yahoo.co': 'yahoo.com',
	'outlok.com': 'outlook.com',
	'outlook.co': 'outlook.com',
	'iclod.com': 'icloud.com',
	'icloud.co': 'icloud.com',
};

export function normalizeEmailInput(value) {
	return (value || '').trim().toLowerCase();
}

export function isValidEmailFormat(email) {
	const normalized = normalizeEmailInput(email);
	return EMAIL_REGEX.test(normalized);
}

/**
 * Suggest a corrected email if the domain looks like a common typo.
 * @returns {string | null}
 */
export function suggestEmailCorrection(email) {
	const normalized = normalizeEmailInput(email);
	if (!normalized.includes('@')) return null;
	const [local, domain] = normalized.split('@');
	if (!local || !domain) return null;
	const fix = DOMAIN_TYPOS[domain];
	if (!fix || fix === domain) return null;
	return `${local}@${fix}`;
}

export function validateEmail(email) {
	const normalized = normalizeEmailInput(email);
	if (!normalized) {
		return { ok: false, error: 'Email is required' };
	}
	if (!EMAIL_REGEX.test(normalized)) {
		return { ok: false, error: 'Please enter a valid email address' };
	}
	return { ok: true, normalized };
}

export const MIN_PASSWORD_LENGTH = 8;

export function validatePassword(password, { confirm } = {}) {
	if (!password) {
		return { ok: false, error: 'Password is required' };
	}
	if (password.length < MIN_PASSWORD_LENGTH) {
		return { ok: false, error: `Password must be at least ${MIN_PASSWORD_LENGTH} characters` };
	}
	if (confirm !== undefined && password !== confirm) {
		return { ok: false, error: 'Passwords do not match' };
	}
	return { ok: true };
}
